/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


$(document).ready(function(){
  $('.slideshow2__slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.27832 8.16656L8.65585 13.5L10 12.1669L5.29454 7.5L10 2.83312L8.65585 1.5L3.27832 6.83344C3.10011 7.01024 3 7.25 3 7.5C3 7.75 3.10011 7.98976 3.27832 8.16656Z" fill="currentColor"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7217 8.16656L6.34415 13.5L5 12.1669L9.70546 7.5L5 2.83312L6.34415 1.5L11.7217 6.83344C11.8999 7.01024 12 7.25 12 7.5C12 7.75 11.8999 7.98976 11.7217 8.16656Z" fill="currentColor"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          fade: true,
          cssEase: 'linear'
        }
      }
    ]
  });
  $('.section-columns__carousel--mobile').slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    mobileFirst: true,
    prevArrow: '<div class="arrow-left"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.27832 8.16656L8.65585 13.5L10 12.1669L5.29454 7.5L10 2.83312L8.65585 1.5L3.27832 6.83344C3.10011 7.01024 3 7.25 3 7.5C3 7.75 3.10011 7.98976 3.27832 8.16656Z" fill="currentColor"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7217 8.16656L6.34415 13.5L5 12.1669L9.70546 7.5L5 2.83312L6.34415 1.5L11.7217 6.83344C11.8999 7.01024 12 7.25 12 7.5C12 7.75 11.8999 7.98976 11.7217 8.16656Z" fill="currentColor"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  });
  $('.featured-collection__slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipe: true,
    prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.carousel--mobile-slider:not(.featured-collection__slider)').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    mobileFirst: true,
    prevArrow: '<div class="arrow-left"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.27832 8.16656L8.65585 13.5L10 12.1669L5.29454 7.5L10 2.83312L8.65585 1.5L3.27832 6.83344C3.10011 7.01024 3 7.25 3 7.5C3 7.75 3.10011 7.98976 3.27832 8.16656Z" fill="currentColor"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7217 8.16656L6.34415 13.5L5 12.1669L9.70546 7.5L5 2.83312L6.34415 1.5L11.7217 6.83344C11.8999 7.01024 12 7.25 12 7.5C12 7.75 11.8999 7.98976 11.7217 8.16656Z" fill="currentColor"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  });

  function closePredictiveSearch() {
    const $box = $('predictive-search');
    if (!$box.is('[open]')) return;
    $box.removeAttr('results');
    $box.removeAttr('open');
    $box.removeClass('is-searched');
    $box.addClass('reset');
    $box.find('#searchInput-').val('');
  }

  $(document).on('click', function (e) {
    const $box = $('predictive-search');
    if (!$box.is(e.target) && $box.has(e.target).length === 0) {
      closePredictiveSearch();
    }
  });

  // Close the search popdown when the cursor leaves the search bar / dropdown,
  // otherwise nav mega-menus open behind the still-open search popdown.
  $(document).on('mouseleave', 'predictive-search', closePredictiveSearch);

  $('.product-grid-item__add-cart .quick__form.has--quantity .quantity__btn[data-quantity-plus]').click(function(){
    var v = parseInt($(this).parent().find('.quantity__input').val()) + 1;
    $(this).parent().find('.quantity__input').val(v);
  });
  $('.product-grid-item__add-cart .quick__form.has--quantity .quantity__btn[data-quantity-minus]').click(function(){
    var temp = parseInt($(this).parent().find('.quantity__input').val());
    if(temp >= 2){
      var v = temp - 1;
    }else{
      var v = 1;
    }
    $(this).parent().find('.quantity__input').val(v);
  });

  $('.mosaic__item__inner.has-link').click(function(){
    $(this).find('.mosaic__item__btn').get(0).click();
  });
  $('.banner-image__inner.has-link').click(function(){
    $(this).find('.banner-image__btn').get(0).click();
  });

  var maxHeight = 0;
  $('#NavStandard .menu__items .menu__item').each(function(){
    var currentHeight = $(this).find('.header__dropdown').height();
    if(maxHeight < currentHeight){
      maxHeight = currentHeight;
    }
  });
  maxHeight = maxHeight - 50;
  $('#NavStandard').append('<style>#NavStandard .menu__items .menu__item .header__dropdown{ height: '+maxHeight+'px !important; }</style>');
});

$(window).on('resize', function () {
  if($(window).width() < 768){
    setTimeout(function () {
      $('.section-columns__carousel--mobile').slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        mobileFirst: true,
        prevArrow: '<div class="arrow-left"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.27832 8.16656L8.65585 13.5L10 12.1669L5.29454 7.5L10 2.83312L8.65585 1.5L3.27832 6.83344C3.10011 7.01024 3 7.25 3 7.5C3 7.75 3.10011 7.98976 3.27832 8.16656Z" fill="currentColor"/></svg></div>',
        nextArrow: '<div class="arrow-right"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7217 8.16656L6.34415 13.5L5 12.1669L9.70546 7.5L5 2.83312L6.34415 1.5L11.7217 6.83344C11.8999 7.01024 12 7.25 12 7.5C12 7.75 11.8999 7.98976 11.7217 8.16656Z" fill="currentColor"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: 'unslick'
          }
        ]
      });
      $('.carousel--mobile-slider:not(.featured-collection__slider)').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        mobileFirst: true,
        prevArrow: '<div class="arrow-left"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.27832 8.16656L8.65585 13.5L10 12.1669L5.29454 7.5L10 2.83312L8.65585 1.5L3.27832 6.83344C3.10011 7.01024 3 7.25 3 7.5C3 7.75 3.10011 7.98976 3.27832 8.16656Z" fill="currentColor"/></svg></div>',
        nextArrow: '<div class="arrow-right"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7217 8.16656L6.34415 13.5L5 12.1669L9.70546 7.5L5 2.83312L6.34415 1.5L11.7217 6.83344C11.8999 7.01024 12 7.25 12 7.5C12 7.75 11.8999 7.98976 11.7217 8.16656Z" fill="currentColor"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: 'unslick'
          }
        ]
      });
    }, 100);
  }
});

$(window).scroll(function() {
  if ($(this).scrollTop() < 100) {
    $('.site-header').removeClass('site-header--hovered');
  }
});

// Sync header cart badge when Rebuy changes the cart. Needed on Boost-rendered
// collection pages, whose add-to-cart bypasses the theme's cart-drawer code
// (which is the only thing that normally updates .cart-number).
(function () {
  function updateCartBadge(itemCount) {
    var count = parseInt(itemCount, 10);
    if (isNaN(count)) return;
    var text = count > 0 ? String(count) : '';
    document.querySelectorAll('.cart-number').forEach(function (el) {
      el.textContent = text;
    });
    document.querySelectorAll('.cart__toggle').forEach(function (el) {
      el.classList.toggle('cart__toggle--has-items', count > 0);
    });
  }

  function syncFromRebuyEvent(event) {
    var detailCart = event && event.detail && event.detail.cart;
    if (detailCart && typeof detailCart.item_count === 'number') {
      updateCartBadge(detailCart.item_count);
      return;
    }
    // Fall back to /cart.js if the event payload doesn't include item_count
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('rebuy:cart.change', syncFromRebuyEvent);
})();

(function () {
  function enPrimeurMessage() {
    var themeStrings = (window.theme && window.theme.strings) || {};
    return themeStrings.en_primeur_warning
      || 'Your cart contains both En Primeur and regular items. En Primeur items cannot be purchased alongside other products. Please remove one type before checking out.';
  }

  function getCartEnPrimeurState() {
    return fetch('/cart?section_id=api-cart-en-primeur', { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var script = doc.querySelector('[data-cart-en-primeur]');
        if (!script) return { is_mixed: false };
        try { return JSON.parse(script.textContent); }
        catch (e) { return { is_mixed: false }; }
      })
      .catch(function () { return { is_mixed: false }; });
  }

  function showBlockMessage() {
    var existing = document.querySelector('[data-en-primeur-toast]');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.setAttribute('data-en-primeur-toast', '');
    toast.setAttribute('role', 'alert');
    toast.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#8B2C2C;color:#fff;padding:16px 20px;border-radius:4px;z-index:2147483647;max-width:520px;box-shadow:0 4px 24px rgba(0,0,0,0.35);font-size:14px;line-height:1.5;font-family:inherit;';

    var text = document.createElement('span');
    text.textContent = enPrimeurMessage();
    toast.appendChild(text);

    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Dismiss';
    close.style.cssText = 'margin-left:14px;background:transparent;border:1px solid #fff;color:#fff;padding:4px 10px;cursor:pointer;border-radius:3px;font-size:12px;';
    close.addEventListener('click', function () { toast.remove(); });
    toast.appendChild(close);

    document.body.appendChild(toast);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 10000);
  }

  function findCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    var direct = (
      el.closest('a[href$="/checkout"], a[href*="/checkout?"], a[href*="/checkout/"]') ||
      el.closest('button[name="checkout"]') ||
      el.closest('[data-checkout], [data-checkout-button]') ||
      el.closest('#nvd-with-checkout-btn, #nvd-without-checkout-btn, [id^="nvd-"][id*="checkout"]')
    );
    if (direct) return direct;

    // Text-based fallback for 3rd-party apps (shipping-protection, upsell apps, etc.)
    // that render their own checkout buttons without standard attributes.
    var candidate = el.closest('button, a[role="button"], [role="button"]');
    if (!candidate) return null;
    var text = (candidate.textContent || '').trim().toLowerCase();
    if (!text) return null;
    if (/\bcheckout\b/.test(text)) return candidate;
    return null;
  }

  function syncCartPageEnPrimeurUI() {
    var cartEl = document.querySelector('cart-element[data-cart-page]');
    if (!cartEl) return;
    getCartEnPrimeurState().then(function (state) {
      var mixed = !!(state && state.is_mixed);
      cartEl.setAttribute('data-ep-mixed', mixed ? 'true' : 'false');
      var nativeBtn = cartEl.querySelector('[data-ep-native-checkout]');
      if (nativeBtn) {
        if (mixed) {
          nativeBtn.setAttribute('disabled', 'disabled');
          nativeBtn.setAttribute('aria-disabled', 'true');
        } else {
          nativeBtn.removeAttribute('disabled');
          nativeBtn.removeAttribute('aria-disabled');
        }
      }
    });
  }

  document.addEventListener('theme:cart:loaded', syncCartPageEnPrimeurUI);
  document.addEventListener('theme:cart:update', syncCartPageEnPrimeurUI);
  document.addEventListener('theme:cart:added', syncCartPageEnPrimeurUI);

  document.addEventListener('click', function (e) {
    var trigger = findCheckoutTrigger(e.target);
    if (!trigger) return;

    if (trigger.hasAttribute('data-en-primeur-checked')) {
      trigger.removeAttribute('data-en-primeur-checked');
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    getCartEnPrimeurState().then(function (state) {
      if (state && state.is_mixed) {
        showBlockMessage();
        return;
      }
      trigger.setAttribute('data-en-primeur-checked', 'true');
      trigger.click();
    });
  }, true);
})();